<div *ngFor="let stageSchema of stageSchemas">
    <dr-review-stage-admin
        [formGroup]="formGroup"
        [stageSchema]="stageSchema"
    ></dr-review-stage-admin>
</div>
